// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import React, { useState, useEffect } from 'react';
import { PlasmicSidebar } from './plasmic/collect_wise_draft/PlasmicSidebar';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { db } from '../firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';

function Sidebar_(props, ref) {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [hasStripeCustomerId, setHasStripeCustomerId] = useState(false);

  useEffect(() => {
    if (!currentUser) return;

    const q = query(
      collection(db, 'userInfo'),
      where('user', '==', currentUser.uid)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      if (snapshot.empty) {
        setHasStripeCustomerId(false);
        return;
      }

      const userInfo = snapshot.docs[0].data();
      setHasStripeCustomerId(!!userInfo.stripe_customer_id);
    });

    return () => unsubscribe();
  }, [currentUser]);

  return (
    <PlasmicSidebar
      root={{ ref }}
      {...props}
      dashboardButton={{
        onClick: () => navigate('/'),
      }}
      paymentsButton={{
        onClick: () => navigate('/paymentslist'),
      }}
      contractsButton={{
        onClick: () => navigate('/contractslist'),
      }}
      clientsButton={{
        onClick: () => {
          if (currentUser.uid === 'cg0KYF8bHvSuyK7BFwPjCrwm0Dp2') {
            navigate('/alldebtors');
          } else {
            navigate('/debtorslist');
          }
        },
      }}
      settingsButton={{
        onClick: () => navigate('/settings/billing'),
      }}
      rolesBtn={{
        onClick: () => navigate('/roles'),
      }}
      settingsButton2={{
        onClick: () => navigate('/usage'),
        style: { display: hasStripeCustomerId ? 'flex' : 'none' },
      }}
      callHistoryButton={{
        onClick: () => navigate('/calls/history'),
      }}
    />
  );
}

const Sidebar = React.forwardRef(Sidebar_);

export default Sidebar;
